import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Features from "components/Features.js";
import QuoteBanner from "components/QuoteBanner.js";
import Service from "components/Service.js";
import ServiceTwo from "components/ServiceTwo.js";
import ServiceThree from "components/ServiceThree.js";
import Footer from "components/Footer.js";
import HeaderComponent from "components/HeaderComponent.js";
import SeoComponent from "components/SeoComponent.js";
import FeatureList from "components/FeatureList.js";
import ServiceList from "components/ServiceList.js";
import Fleets from "components/Fleets.js";
import Info from "components/Info.js";
import ContactForm from "components/ContactForm.js";
import ContactInfo from "components/ContactInfo.js";
import ContactMap from "components/ContactMap.js";
import Page from "components/Page.js";
import Fleet from "book/fleet.js";
import Passenger from "book/passenger.js";
import BookingConfirm from "book/confirm.js";
import BookingPayment from "book/payment.js";
import BookingThank from "book/thankyou.js";
import {getRequests} from "../helpers/ApiHelper";

export default class HotelTravelLandingPage extends React.Component {

    pageLoading = true;
    constructor(props) {
        super(props);
        this.state = {
            page: {
                sections:[],
                section_list:[],
            },
            seo:{},
            statistics:[],
            fleets:[],
            quoteData: {
                address_types: [],
                additionalChargeDate: '',
                rateData: '',
                fleet_class_types: ''
            },
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(changeObject) {
        this.setState(changeObject)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        getRequests(this.props.currentRoute).then(data => {
            this.pageLoading = false;
                const quoteData = {
                    address_types:(data.address_types !== undefined ? data.address_types : []),
                    rateData:(data .rateDate !== undefined ? data.rateDate : ''),
                    additionalChargeDate:(data.additionalChargeDate !== undefined ? data.additionalChargeDate : ''),
                    fleet_class_types:(data.fleet_class_types !== undefined ? data.fleet_class_types : '')
                };
                this.handleChange({
                    page: data.page,
                    seo: data.seo,
                    statistics:(data.statistics !== undefined ? data.statistics : []),
                    fleets:(data.fleets !== undefined ? data.fleets : []),
                    quoteData:quoteData
                });


        });
    }

    render()
    {
        return (

            <AnimationRevealPage>
                <SeoComponent seoData={this.state.seo}/>
                <HeaderComponent headerData={this.props.pageData}/>
                {this.pageLoading &&

                <div className="loader-wrapper">
                    <div className="  loader">
                        <span>L</span>
                        <span>o</span>
                        <span>a</span>
                        <span>d</span>
                        <span>i</span>
                        <span>n</span>
                        <span>g</span>
                    </div>
                </div>

                }
                    {this.state.page.section_list.map((section, index) =>{
                            const sectionData = this.state.page.sections.find((single) => {
                                return single.name === section && single.type === 'field';
                            });
                            if(sectionData !== undefined) {
                                const listData = this.state.page.sections.filter((single) => {
                                    return single.name === section && single.type === 'list';
                                });
                                if(section === "quote-banner" ){

                                    return <QuoteBanner key={index} fieldData={sectionData} quoteData={this.state.quoteData} > </QuoteBanner>
                                }
                                if(section === "feature" ){
                                    return <Features key={index} fieldData={sectionData} listData={listData} > </Features>
                                }
                                if(section === "services" ){
                                    return <Service key={index} fieldData={sectionData} listData={listData} > </Service>
                                }
                                if(section === "services-second" ){
                                    return <ServiceTwo key={index} fieldData={sectionData} listData={listData} > </ServiceTwo>
                                }
                                if(section === "feature-list" ){
                                    return <FeatureList key={index} fieldData={sectionData} listData={listData} > </FeatureList>
                                }
                                if(section === "service-list" ){
                                    return <ServiceList key={index} fieldData={sectionData} listData={listData} > </ServiceList>
                                }
                                if(section === "service-three" ){
                                    return <ServiceThree key={index} fieldData={sectionData} statisticsData={this.state.statistics}> </ServiceThree>
                                }
                                if(section === "fleets" ){
                                    return <Fleets key={index} fieldData={sectionData} fleetsData={this.state.fleets}> </Fleets>
                                }
                                if(section === "info" ){
                                    return <Info key={index} fieldData={sectionData}> </Info>
                                }
                                if(section === "contact-form" ){
                                    return <ContactForm key={index} fieldData={sectionData}> </ContactForm>
                                }
                                if(section === "contact-info" ){
                                    return <ContactInfo key={index} fieldData={sectionData} extraData={this.props.pageData}> </ContactInfo>
                                }
                                if(section === "contact-map" ){
                                    return <ContactMap key={index} fieldData={sectionData}> </ContactMap>
                                }
                                if(section === "page-html" ){
                                    return <Page key={index} fieldData={sectionData}> </Page>
                                }
                                if(section === "book-fleet" ){

                                    return <Fleet key={index}/>
                                }
                                if(section === "book-passenger" ){

                                    return <Passenger key={index}/>
                                }
                                if(section === "book-confirm" ){

                                    return <BookingConfirm key={index}/>
                                }
                                if(section === "book-payment" ){

                                    return <BookingPayment key={index}/>
                                }
                                if(section === "book-thank" ){

                                    return <BookingThank key={index}/>
                                }
                            }
                        return null;
                        })}

                <Footer footerData={this.props.pageData}/>

            </AnimationRevealPage>

        );
    }
}
